import { useMutation } from '@tanstack/react-query';
import { API } from '~/shared/API/api';

export const useAddCar = (onSuccess: () => void) => {
  const mutation = useMutation({
    mutationFn: (data: { number: string; name: string }) =>
      API.addCar(data.number, data.name),
    onSuccess: () => {
      onSuccess();
    },
    onError: (data) => {
      console.log(data);
    },
  });

  return {
    addCar: mutation.mutate,
    data: mutation.data,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isPending,
    errorAdd: mutation.error,
  };
};
